// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as Window$OrcaPaymentPage from "./Window.bs.js";
import * as S3Utils$OrcaPaymentPage from "./Utilities/S3Utils.bs.js";
import * as CardTheme$OrcaPaymentPage from "./CardTheme.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./Utilities/ApiEndpoint.bs.js";
import * as CommonHooks$OrcaPaymentPage from "./Hooks/CommonHooks.bs.js";
import * as ElementType$OrcaPaymentPage from "./Types/ElementType.bs.js";
import * as PaymentType$OrcaPaymentPage from "./Types/PaymentType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as DefaultTheme$OrcaPaymentPage from "./DefaultTheme.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "./Hooks/UtilityHooks.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as RecoilAtomsV2$OrcaPaymentPage from "./Utilities/RecoilAtomsV2.bs.js";
import * as UnifiedHelpersV2$OrcaPaymentPage from "./Utilities/UnifiedHelpersV2.bs.js";
import * as UpdateIntentOverlay$OrcaPaymentPage from "./Components/UpdateIntentOverlay.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function LoaderController(props) {
  var initTimestamp = props.initTimestamp;
  var logger = props.logger;
  var setIntegrateErrorError = props.setIntegrateErrorError;
  var paymentMode = props.paymentMode;
  var match = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.configAtom);
  var setConfig = match[1];
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.keys);
  var setKeys = match$1[1];
  var keys = match$1[0];
  var match$2 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.paymentMethodList);
  var setPaymentMethodList = match$2[1];
  var paymentMethodList = match$2[0];
  var match$3 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.sessions);
  var setSessions = match$3[1];
  var match$4 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.elementOptions);
  var setOptions = match$4[1];
  var options = match$4[0];
  var match$5 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var setOptionsPayment = match$5[1];
  var optionsPayment = match$5[0];
  var setPaymentManagementList = Recoil.useSetRecoilState(RecoilAtomsV2$OrcaPaymentPage.paymentManagementList);
  var setSessionId = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.sessionId);
  var setBlockConfirm = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isConfirmBlocked);
  var setCustomPodUri = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.customPodUri);
  var setIsGooglePayReady = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isGooglePayReady);
  var setTrustPayScriptStatus = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.trustPayScriptStatus);
  var setIsApplePayReady = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isApplePayReady);
  var setIsSamsungPayReady = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isSamsungPayReady);
  var setUpdateSession = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.updateSession);
  var setIsUpdateIntentLoading = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isUpdateIntentLoading);
  var match$6 = React.useState(function () {
        return 0.0;
      });
  var setDivH = match$6[1];
  var divH = match$6[0];
  var match$7 = React.useState(function () {
        return 0.0;
      });
  var paymentMethodOrder = optionsPayment.paymentMethodOrder;
  var setLaunchTime = match$7[1];
  var launchTime = match$7[0];
  var match$8 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.paymentMethodCollectOptionAtom);
  var setPaymentMethodCollectOptions = match$8[1];
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  var divRef = React.useRef(null);
  var iframeId = keys.iframeId;
  var config = match[0].config;
  var messageParentWindow = function (data) {
    Utils$OrcaPaymentPage.messageParentWindow(keys.parentURL, data);
  };
  var setUserFullName = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userFullName);
  var setUserEmail = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userEmailAddress);
  var setUserAddressline1 = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressline1);
  var setUserAddressline2 = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressline2);
  var setUserAddressCity = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressCity);
  var setUserAddressPincode = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressPincode);
  var setUserAddressState = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressState);
  var setUserAddressCountry = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userAddressCountry);
  var setCountry = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userCountry);
  var setIsCompleteCallbackUsed = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  var setIsPaymentButtonHandlerProvided = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isPaymentButtonHandlerProvidedAtom);
  var setIsTestMode = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.isTestMode);
  var updateOptions = function (dict) {
    var optionsDict = Utils$OrcaPaymentPage.getDictFromObj(dict, "options");
    var match = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
    switch (match) {
      case "Card" :
      case "CardNumberElement" :
      case "CardExpiryElement" :
      case "CardCVCElement" :
          break;
      case "PaymentMethodCollectElement" :
          var paymentMethodCollectOptions = PaymentMethodCollectUtils$OrcaPaymentPage.itemToObjMapper(optionsDict);
          return setPaymentMethodCollectOptions(function (param) {
                      return paymentMethodCollectOptions;
                    });
      case "NONE" :
          return ;
      default:
        var paymentOptions = PaymentType$OrcaPaymentPage.itemToObjMapper(optionsDict, logger);
        setOptionsPayment(function (param) {
              return paymentOptions;
            });
        [
            [
              paymentOptions.defaultValues.billingDetails.name,
              setUserFullName
            ],
            [
              paymentOptions.defaultValues.billingDetails.email,
              setUserEmail
            ],
            [
              paymentOptions.defaultValues.billingDetails.address.line1,
              setUserAddressline1
            ],
            [
              paymentOptions.defaultValues.billingDetails.address.line2,
              setUserAddressline2
            ],
            [
              paymentOptions.defaultValues.billingDetails.address.city,
              setUserAddressCity
            ],
            [
              paymentOptions.defaultValues.billingDetails.address.postal_code,
              setUserAddressPincode
            ],
            [
              paymentOptions.defaultValues.billingDetails.address.state,
              setUserAddressState
            ],
            [
              paymentOptions.defaultValues.billingDetails.address.country,
              setUserAddressCountry
            ]
          ].forEach(function (val) {
              var value = val[0];
              if (value !== "") {
                return val[1](function (prev) {
                            var newrecord = Caml_obj.obj_dup(prev);
                            newrecord.value = value;
                            return newrecord;
                          });
              }
              
            });
        if (paymentOptions.defaultValues.billingDetails.address.country === "") {
          var clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          var clientCountry = Utils$OrcaPaymentPage.getClientCountry(clientTimeZone);
          setUserAddressCountry(function (prev) {
                var newrecord = Caml_obj.obj_dup(prev);
                newrecord.value = clientCountry.countryName;
                return newrecord;
              });
          return setCountry(function (param) {
                      return clientCountry.countryName;
                    });
        }
        setUserAddressCountry(function (prev) {
              var newrecord = Caml_obj.obj_dup(prev);
              newrecord.value = paymentOptions.defaultValues.billingDetails.address.country;
              return newrecord;
            });
        return setCountry(function (param) {
                    return paymentOptions.defaultValues.billingDetails.address.country;
                  });
    }
    setOptions(function (param) {
          return ElementType$OrcaPaymentPage.itemToObjMapper(optionsDict, logger);
        });
  };
  var setConfigs = async function (dict, themeValues) {
    try {
      var paymentOptions = Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions");
      var optionsDict = Utils$OrcaPaymentPage.getDictFromObj(dict, "options");
      var $$default = themeValues.default;
      var defaultRules = themeValues.defaultRules;
      var config = CardTheme$OrcaPaymentPage.itemToObjMapper(paymentOptions, $$default, defaultRules, logger);
      var optionsLocaleString = Utils$OrcaPaymentPage.getWarningString(optionsDict, "locale", "", logger);
      var optionsAppearance = CardTheme$OrcaPaymentPage.getAppearance("appearance", optionsDict, $$default, defaultRules, logger);
      var appearance = Caml_obj.equal(optionsAppearance, CardTheme$OrcaPaymentPage.defaultAppearance) ? config.appearance : optionsAppearance;
      var localeString = await CardTheme$OrcaPaymentPage.getLocaleObject(optionsLocaleString === "" ? config.locale : optionsLocaleString);
      var constantString = await CardTheme$OrcaPaymentPage.getConstantStringsObject();
      await S3Utils$OrcaPaymentPage.initializeCountryData(config.locale, logger);
      return setConfig(function (param) {
                  return {
                          config: {
                            appearance: appearance,
                            locale: config.locale === "auto" ? window.navigator.language : config.locale,
                            pmSessionId: config.pmSessionId,
                            clientSecret: config.clientSecret,
                            fonts: config.fonts,
                            loader: config.loader,
                            sdkAuthorization: config.sdkAuthorization
                          },
                          themeObj: appearance.variables,
                          localeString: localeString,
                          constantString: constantString,
                          showLoader: config.loader === "Auto" || config.loader === "Always"
                        };
                });
    }
    catch (exn){
      return ;
    }
  };
  var updateRedirectionFlags = UtilityHooks$OrcaPaymentPage.useUpdateRedirectionFlags();
  React.useEffect((function () {
          messageParentWindow([[
                  "iframeMounted",
                  true
                ]]);
          messageParentWindow([
                [
                  "applePayMounted",
                  true
                ],
                [
                  "componentName",
                  componentName
                ]
              ]);
          logger.setLogInitiated();
          var updatedState;
          updatedState = typeof paymentMethodList !== "object" && paymentMethodList === "Loading" ? (
              Utils$OrcaPaymentPage.checkPriorityList(paymentMethodOrder) ? "SemiLoaded" : "Loading"
            ) : paymentMethodList;
          var finalLoadLatency = launchTime <= 0.0 ? 0.0 : Date.now() - launchTime;
          if (typeof updatedState !== "object") {
            if (updatedState === "Loading") {
              logger.setLogInfo("Loading", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
            } else {
              setPaymentMethodList(function (param) {
                    return updatedState;
                  });
              logger.setLogInfo("SemiLoaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
            }
          } else if (updatedState.TAG === "Loaded") {
            logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
          } else {
            logger.setLogError("LoadError: " + JSON.stringify(updatedState._0), "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
          }
          window.addEventListener("click", (function (ev) {
                  Utils$OrcaPaymentPage.handleOnClickPostMessage(keys.parentURL, ev);
                }));
          return (function () {
                    window.removeEventListener("click", (function (ev) {
                            Utils$OrcaPaymentPage.handleOnClickPostMessage(keys.parentURL, ev);
                          }));
                  });
        }), []);
  React.useEffect((function () {
          CardUtils$OrcaPaymentPage.generateFontsLink(config.fonts);
          var dict = Utils$OrcaPaymentPage.getDictFromJson(config.appearance.rules);
          if (Object.entries(dict).length > 0) {
            Utils$OrcaPaymentPage.generateStyleSheet("", dict, "themestyle");
          }
          var match = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
          if (match !== "Payment") {
            var styleClass = [
              [
                "input-base",
                Utils$OrcaPaymentPage.getDictFromJson(options.style.base)
              ],
              [
                "input-complete",
                Utils$OrcaPaymentPage.getDictFromJson(options.style.complete)
              ],
              [
                "input-invalid",
                Utils$OrcaPaymentPage.getDictFromJson(options.style.invalid)
              ],
              [
                "input-empty",
                Utils$OrcaPaymentPage.getDictFromJson(options.style.empty)
              ]
            ];
            styleClass.map(function (item) {
                  var dict = item[1];
                  if (Object.entries(dict).length > 0) {
                    Utils$OrcaPaymentPage.generateStyleSheet(item[0], dict, "widgetstyle");
                    return ;
                  }
                  
                });
          }
          
        }), [config]);
  React.useEffect((function () {
          var handleFun = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            try {
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentElementCreate")) {
                if (Utils$OrcaPaymentPage.getDictIsSome(dict, "iframeId")) {
                  setKeys(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.iframeId = Utils$OrcaPaymentPage.getString(dict, "iframeId", "no-element");
                        return newrecord;
                      });
                }
                if (Core__Option.getOr(Core__Option.flatMap(dict["paymentElementCreate"], Core__JSON.Decode.bool), false)) {
                  if (Core__Option.getOr(Core__Option.flatMap(dict["otherElements"], Core__JSON.Decode.bool), false)) {
                    updateOptions(dict);
                  } else {
                    var sdkSessionId = Utils$OrcaPaymentPage.getString(dict, "sdkSessionId", "no-element");
                    logger.setSessionId(sdkSessionId);
                    if (isIntegrationEnv) {
                      setBlockConfirm(function (param) {
                            return Utils$OrcaPaymentPage.getBool(dict, "blockConfirm", false);
                          });
                    }
                    setCustomPodUri(function (param) {
                          return Utils$OrcaPaymentPage.getString(dict, "customPodUri", "");
                        });
                    setSessionId(function (param) {
                          return sdkSessionId;
                        });
                    if (Utils$OrcaPaymentPage.getDictIsSome(dict, "publishableKey")) {
                      var publishableKey = Utils$OrcaPaymentPage.getString(dict, "publishableKey", "");
                      logger.setMerchantId(publishableKey);
                    }
                    if (Utils$OrcaPaymentPage.getDictIsSome(dict, "analyticsMetadata")) {
                      var metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "analyticsMetadata");
                      logger.setMetadata(metadata);
                    }
                    if (Utils$OrcaPaymentPage.getDictIsSome(dict, "onCompleteDoThisUsed")) {
                      var isCallbackUsedVal = Utils$OrcaPaymentPage.getBool(dict, "onCompleteDoThisUsed", false);
                      setIsCompleteCallbackUsed(function (param) {
                            return isCallbackUsedVal;
                          });
                    }
                    if (Utils$OrcaPaymentPage.getDictIsSome(dict, "isPaymentButtonHandlerProvided")) {
                      var isSDKClick = Utils$OrcaPaymentPage.getBool(dict, "isPaymentButtonHandlerProvided", false);
                      setIsPaymentButtonHandlerProvided(function (param) {
                            return isSDKClick;
                          });
                    }
                    if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentOptions")) {
                      var paymentOptions = Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions");
                      var clientSecret = Utils$OrcaPaymentPage.getWarningString(paymentOptions, "clientSecret", "", logger);
                      var pmSessionId = Utils$OrcaPaymentPage.getWarningString(paymentOptions, "pmSessionId", "", logger);
                      var sdkAuthorization = Utils$OrcaPaymentPage.getString(paymentOptions, "sdkAuthorization", "");
                      setKeys(function (prev) {
                            var newrecord = Caml_obj.obj_dup(prev);
                            newrecord.pmSessionId = pmSessionId;
                            newrecord.sdkAuthorization = sdkAuthorization;
                            newrecord.clientSecret = clientSecret;
                            return newrecord;
                          });
                      logger.setClientSecret(clientSecret);
                      logger.setSdkAuthorization(sdkAuthorization);
                      updateRedirectionFlags(paymentOptions);
                      var promise = Utils$OrcaPaymentPage.getThemePromise(paymentOptions);
                      if (promise !== undefined) {
                        Core__Promise.$$catch(Caml_option.valFromOption(promise).then(function (res) {
                                  return setConfigs(dict, res);
                                }), (function (param) {
                                return setConfigs(dict, {
                                            default: DefaultTheme$OrcaPaymentPage.default,
                                            defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                                          });
                              }));
                      } else {
                        setConfigs(dict, {
                              default: DefaultTheme$OrcaPaymentPage.default,
                              defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                            });
                      }
                    }
                    var newLaunchTime = Utils$OrcaPaymentPage.getFloat(dict, "launchTime", 0.0);
                    setLaunchTime(function (param) {
                          return newLaunchTime;
                        });
                    var initLoadlatency = Date.now() - newLaunchTime;
                    logger.setLogInfo(Window$OrcaPaymentPage.hrefWithoutSearch, "APP_RENDERED", undefined, initLoadlatency, undefined, undefined, undefined);
                    [
                        [
                          "iframeId",
                          "no-element"
                        ],
                        [
                          "publishableKey",
                          ""
                        ],
                        [
                          "paymentId",
                          ""
                        ],
                        [
                          "parentURL",
                          "*"
                        ],
                        [
                          "sdkHandleOneClickConfirmPayment",
                          true
                        ]
                      ].forEach(function (keyPair) {
                          CommonHooks$OrcaPaymentPage.updateKeys(dict, keyPair, setKeys);
                        });
                    var renderLatency = Date.now() - initTimestamp;
                    logger.setLogInfo("", "PAYMENT_OPTIONS_PROVIDED", undefined, renderLatency, undefined, undefined, undefined);
                    updateOptions(dict);
                  }
                } else if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentOptions")) {
                  var paymentOptions$1 = Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions");
                  var clientSecret$1 = Utils$OrcaPaymentPage.getWarningString(paymentOptions$1, "clientSecret", "", logger);
                  var pmSessionId$1 = Utils$OrcaPaymentPage.getWarningString(paymentOptions$1, "pmSessionId", "", logger);
                  var sdkAuthorization$1 = Utils$OrcaPaymentPage.getString(paymentOptions$1, "sdkAuthorization", "");
                  setKeys(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.pmSessionId = pmSessionId$1;
                        newrecord.sdkAuthorization = sdkAuthorization$1;
                        newrecord.clientSecret = clientSecret$1;
                        return newrecord;
                      });
                  logger.setClientSecret(clientSecret$1);
                  logger.setSdkAuthorization(sdkAuthorization$1);
                  updateRedirectionFlags(paymentOptions$1);
                  var promise$1 = Utils$OrcaPaymentPage.getThemePromise(paymentOptions$1);
                  if (promise$1 !== undefined) {
                    Core__Promise.$$catch(Caml_option.valFromOption(promise$1).then(function (res) {
                              return setConfigs(dict, res);
                            }), (function (param) {
                            return setConfigs(dict, {
                                        default: DefaultTheme$OrcaPaymentPage.default,
                                        defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                                      });
                          }));
                  } else {
                    setConfigs(dict, {
                          default: DefaultTheme$OrcaPaymentPage.default,
                          defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                        });
                  }
                }
                
              } else if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentElementsUpdate")) {
                updateOptions(dict);
              } else if (Utils$OrcaPaymentPage.getDictIsSome(dict, "ElementsUpdate")) {
                var optionsDict = Utils$OrcaPaymentPage.getDictFromObj(dict, "options");
                var clientSecret$2 = dict["clientSecret"];
                if (clientSecret$2 !== undefined) {
                  setKeys(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.clientSecret = Utils$OrcaPaymentPage.getStringFromJson(clientSecret$2, "");
                        return newrecord;
                      });
                  setConfig(function (prev) {
                        var init = prev.config;
                        return {
                                config: {
                                  appearance: init.appearance,
                                  locale: init.locale,
                                  pmSessionId: init.pmSessionId,
                                  clientSecret: Utils$OrcaPaymentPage.getStringFromJson(clientSecret$2, ""),
                                  fonts: init.fonts,
                                  loader: init.loader,
                                  sdkAuthorization: init.sdkAuthorization
                                },
                                themeObj: prev.themeObj,
                                localeString: prev.localeString,
                                constantString: prev.constantString,
                                showLoader: prev.showLoader
                              };
                      });
                }
                var sdkAuthorization$2 = dict["sdkAuthorization"];
                if (sdkAuthorization$2 !== undefined) {
                  setKeys(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.sdkAuthorization = Utils$OrcaPaymentPage.getStringFromJson(sdkAuthorization$2, "");
                        return newrecord;
                      });
                  setConfig(function (prev) {
                        var init = prev.config;
                        return {
                                config: {
                                  appearance: init.appearance,
                                  locale: init.locale,
                                  pmSessionId: init.pmSessionId,
                                  clientSecret: init.clientSecret,
                                  fonts: init.fonts,
                                  loader: init.loader,
                                  sdkAuthorization: Utils$OrcaPaymentPage.getStringFromJson(sdkAuthorization$2, "")
                                },
                                themeObj: prev.themeObj,
                                localeString: prev.localeString,
                                constantString: prev.constantString,
                                showLoader: prev.showLoader
                              };
                      });
                }
                if (Object.keys(optionsDict).length > 0) {
                  var promise$2 = Utils$OrcaPaymentPage.getThemePromise(optionsDict);
                  if (promise$2 !== undefined) {
                    Core__Promise.$$catch(Caml_option.valFromOption(promise$2).then(function (res) {
                              return setConfigs(dict, res);
                            }), (function (param) {
                            return setConfigs(dict, {
                                        default: DefaultTheme$OrcaPaymentPage.default,
                                        defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                                      });
                          }));
                  } else {
                    setConfigs(dict, {
                          default: DefaultTheme$OrcaPaymentPage.default,
                          defaultRules: DefaultTheme$OrcaPaymentPage.defaultRules
                        });
                  }
                }
                
              }
              if (Core__Option.isSome(dict["isTestMode"])) {
                var isTestMode = Utils$OrcaPaymentPage.getBool(dict, "isTestMode", false);
                setIsTestMode(function (param) {
                      return isTestMode;
                    });
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "sessions")) {
                setSessions(function (param) {
                      return {
                              TAG: "Loaded",
                              _0: Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "sessions")
                            };
                    });
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "sessionUpdate")) {
                setUpdateSession(function (param) {
                      return Core__Option.getOr(Core__JSON.Decode.bool(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "sessionUpdate")), false);
                    });
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "isReadyToPay")) {
                setIsGooglePayReady(function (param) {
                      return Core__Option.getOr(Core__JSON.Decode.bool(Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "isReadyToPay")), false);
                    });
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "trustPayScriptStatus")) {
                setTrustPayScriptStatus(function (param) {
                      var match = Utils$OrcaPaymentPage.getString(dict, "trustPayScriptStatus", "");
                      switch (match) {
                        case "failed" :
                            return "Failed";
                        case "loaded" :
                            return "Loaded";
                        case "loading" :
                            return "Loading";
                        default:
                          return "NotLoaded";
                      }
                    });
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "isSamsungPayReady")) {
                setIsSamsungPayReady(function (param) {
                      return Utils$OrcaPaymentPage.getBool(dict, "isSamsungPayReady", false);
                    });
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "customBackendUrl") && Utils$OrcaPaymentPage.getString(dict, "customBackendUrl", "").length > 0 && Utils$OrcaPaymentPage.getDictIsSome(dict, "endpoint")) {
                var endpoint = Utils$OrcaPaymentPage.getString(dict, "endpoint", "");
                if (endpoint !== "") {
                  ApiEndpoint$OrcaPaymentPage.setApiEndPoint(endpoint);
                }
                
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentMethodList")) {
                var paymentMethodList$1 = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "paymentMethodList");
                var listDict = Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList$1);
                if (optionsPayment.business.name === "") {
                  setOptionsPayment(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.business = {
                          name: Utils$OrcaPaymentPage.getString(listDict, "merchant_name", "")
                        };
                        return newrecord;
                      });
                }
                var finalLoadLatency = launchTime <= 0.0 ? 0.0 : Date.now() - launchTime;
                var updatedState;
                if (Caml_obj.equal(paymentMethodList$1, {})) {
                  updatedState = {
                    TAG: "LoadError",
                    _0: paymentMethodList$1
                  };
                } else {
                  var match = listDict["error"];
                  if (match !== undefined) {
                    updatedState = {
                      TAG: "LoadError",
                      _0: paymentMethodList$1
                    };
                  } else {
                    var isNonEmptyPaymentMethodList = Utils$OrcaPaymentPage.getArray(listDict, "payment_methods").length > 0;
                    updatedState = isNonEmptyPaymentMethodList ? ({
                          TAG: "Loaded",
                          _0: paymentMethodList$1
                        }) : ({
                          TAG: "LoadError",
                          _0: paymentMethodList$1
                        });
                  }
                }
                var evalMethodsList = function () {
                  if (typeof updatedState !== "object") {
                    return ;
                  } else if (updatedState.TAG === "Loaded") {
                    return logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
                  } else {
                    return logger.setLogError("LoadError: " + JSON.stringify(updatedState._0), "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
                  }
                };
                if (optionsPayment.displaySavedPaymentMethods) {
                  var match$1 = optionsPayment.customerPaymentMethods;
                  if (typeof match$1 === "object") {
                    if (match$1.TAG === "LoadedSavedCards" && match$1._0.length > 0) {
                      logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency, undefined, undefined, undefined);
                    } else {
                      evalMethodsList();
                    }
                  }
                  
                } else {
                  evalMethodsList();
                }
                setPaymentMethodList(function (param) {
                      return updatedState;
                    });
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "customerPaymentMethods")) {
                var customerPaymentMethods = PaymentType$OrcaPaymentPage.createCustomerObjArr(dict, "customerPaymentMethods");
                setOptionsPayment(function (prev) {
                      var newrecord = Caml_obj.obj_dup(prev);
                      newrecord.customerPaymentMethods = customerPaymentMethods;
                      return newrecord;
                    });
                var finalLoadLatency$1 = launchTime <= 0.0 ? 0.0 : Date.now() - launchTime;
                var evalMethodsList$1 = function () {
                  if (typeof paymentMethodList !== "object") {
                    return ;
                  } else if (paymentMethodList.TAG === "Loaded") {
                    return logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency$1, undefined, undefined, undefined);
                  } else {
                    return logger.setLogError("LoadError: " + JSON.stringify(paymentMethodList._0), "LOADER_CHANGED", undefined, finalLoadLatency$1, undefined, undefined, undefined);
                  }
                };
                var match$2 = optionsPayment.customerPaymentMethods;
                if (typeof match$2 === "object") {
                  if (match$2.TAG === "LoadedSavedCards" && match$2._0.length > 0) {
                    logger.setLogInfo("Loaded", "LOADER_CHANGED", undefined, finalLoadLatency$1, undefined, undefined, undefined);
                  } else {
                    evalMethodsList$1();
                  }
                }
                
              }
              if (Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentManagementMethods")) {
                var paymentManagementMethods = UnifiedHelpersV2$OrcaPaymentPage.createPaymentsObjArr(dict, "paymentManagementMethods");
                setPaymentManagementList(function (param) {
                      return paymentManagementMethods;
                    });
              }
              if (Core__Option.isSome(dict["applePayCanMakePayments"])) {
                setIsApplePayReady(function (param) {
                      return true;
                    });
              }
              if (Core__Option.isSome(dict["applePaySessionObjNotPresent"])) {
                setIsApplePayReady(function (prev) {
                      return false;
                    });
              }
              if (Core__Option.isSome(dict["updateIntentLoading"])) {
                return setIsUpdateIntentLoading(function (param) {
                            return Utils$OrcaPaymentPage.getBool(dict, "updateIntentLoading", false);
                          });
              } else {
                return ;
              }
            }
            catch (exn){
              return setIntegrateErrorError(function (param) {
                          return true;
                        });
            }
          };
          return Utils$OrcaPaymentPage.handleMessage(handleFun, "Error in parsing sent Data");
        }), [
        paymentMethodOrder,
        optionsPayment
      ]);
  var observer = new ResizeObserver((function (entries) {
          entries.map(function (item) {
                setDivH(function (param) {
                      return item.contentRect.height;
                    });
              });
        }));
  var r = divRef.current;
  if (!(r == null)) {
    observer.observe(r);
  }
  React.useEffect((function () {
          var iframeHeight = divH === 0.0 ? divH : divH + 1.0;
          messageParentWindow([
                [
                  "iframeHeight",
                  iframeHeight
                ],
                [
                  "iframeId",
                  iframeId
                ]
              ]);
        }), [
        divH,
        iframeId
      ]);
  return React.createElement("div", {
              ref: Caml_option.some(divRef),
              className: "relative"
            }, React.createElement(UpdateIntentOverlay$OrcaPaymentPage.make, {}), props.children);
}

var make = LoaderController;

export {
  make ,
}
/* react Not a pure module */
